import { AppointmentInformation, BookingIntroTitle } from '../components';
import { BookingReview, TreatmentListDetails, TotalPriceDetails } from '../routes/complete-page';

import { selectTreatmentPath } from './path.config';

export const config = {
  bookAnotherAppointmentLink: {
    title: 'Book another treatment',
    ref: shopName => `/appointments/beauty/${selectTreatmentPath(shopName)}`,
  },
  SuccessBookingMessage: {
    paragraph: BookingIntroTitle,
  },
  BookingReview: {
    icsEvent: {
      timeBeforeAppointment: 10,
    },
    displayUserAddress: false,
    BookingReviewComponent: BookingReview,
    TreatmentListDetailsComponent: TreatmentListDetails,
    TotalPriceDetailsComponent: TotalPriceDetails,
  },
  BookingInformation: {
    appointmentInformation: AppointmentInformation,
  },
};
